import React, { useState, useEffect, useCallback } from 'react'
import map from 'lodash/map'
import debounce from 'lodash/debounce'

import { Pagination } from '@mui/material'
import axios from 'axios'
import { t } from '../../i18n'
import SectionTitle from '../shared/sectionTitle'
import { LocalizationContextType } from '../shared/contexts'
import { formatTenantDateTime } from '../../utils/formatTenantDateTime'
import { TIME_SOURCE, timeSourceTitle } from '../../utils/timeSource'

const scope = 'sms_notifications'

const SmsNotificationRow = ({ smsNotification, localizationContext }) => {
  return (
    <tr>
      <td>{smsNotification.is_admin_sms ? 'admin_user' : smsNotification.phone_number}</td>
      <td>{smsNotification.order_number}</td>
      <td>{smsNotification.message_type}</td>
      <td>{smsNotification.status}</td>
      <td>{smsNotification.message}</td>
      <td>{smsNotification.error_message || ""}</td>
      <td title={timeSourceTitle(smsNotification.created_at, TIME_SOURCE.app)}>
        {formatTenantDateTime(smsNotification.created_at, localizationContext)}
      </td>
    </tr>
  )
}

const SmsNotificationsList = ({ page: initialPage, pageCount: initialPageCount, smsNotifications: initialSmsNotifications, localization_context: localizationContext }: { page?: number, pageCount?: number, smsNotifications: any[], localization_context?: LocalizationContextType }) => {
  const [smsNotifications, setSmsNotifications] = useState(initialSmsNotifications)

  const [currentPage, setCurrentPage] = useState(initialPage || 1)
  const [pageCount, setPageCount] = useState(initialPageCount || 1)
  const [search, setSearch] = useState('')

  const handleSearch = useCallback(debounce((newSearchValue: string) => {
    setSearch(newSearchValue)
    setCurrentPage(1)
  }, 300), [])

  const fetchSmsNotifications = () => {
    axios.get(`/admin/sms_notifications`, {
      params: {
        page: currentPage,
        search: search
    }})
    .then(({data}) => {
      setSmsNotifications(data.smsNotifications)
      setPageCount(data.pageCount || 1)
      setCurrentPage(data.page || 1)
    })
  }

  useEffect(() => {
    fetchSmsNotifications()
  }, [currentPage, search])

  return (
    <>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <SectionTitle rows={['All', 'SMS Notifications']} />
        <input
          style={{ maxWidth: '400px' }}
          type='search' autoFocus
          name='q'
          className='form-control'
          autoComplete='off'
          placeholder={'Search by phone number'}
          defaultValue={search}
          onChange={(e) => handleSearch(e.target.value)}
        />
      </div>
      <table className='table table-robis table-order-queue'>
        <thead className='thead-robis'>
          <tr>
            <th>{t('phone_number', { scope })}</th>
            <th>{t('order_number', { scope })}</th>
            <th>{t('message_type', { scope })}</th>
            <th>{t('status', { scope })}</th>
            <th>{t('message', { scope })}</th>
            <th>{t('error_message', { scope })}</th>
            <th>{t('sent_at', { scope })}</th>
          </tr>
        </thead>
        <tbody>
          {map(smsNotifications, smsNotification =>
            <SmsNotificationRow
              key={smsNotification.id}
              smsNotification={smsNotification}
              localizationContext={localizationContext}
            />
          )}
        </tbody>
      </table>
      <Pagination
        count={pageCount}
        size='large'
        page={currentPage}
        variant='outlined'
        shape='rounded'
        onChange={(e, page) => setCurrentPage(page)}
      />
    </>
  )
}

export default SmsNotificationsList
